export default {
  "content": "<path d=\"M24.5 6c-9.92 0-18 8.08-18 18s8.08 18 18 18 18-8.08 18-18-8.08-18-18-18zm14 18c0 3.14-1.06 6.04-2.8 8.36L16.14 12.8c2.32-1.74 5.22-2.8 8.36-2.8 7.72 0 14 6.28 14 14zm-28 0c0-3.14 1.06-6.04 2.8-8.36L32.86 35.2c-2.32 1.74-5.22 2.8-8.36 2.8-7.72 0-14-6.28-14-14z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 49 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};